import { saga as iiifResourceSaga } from './spaces/iiif-resource';
import { saga as collectionSaga } from './spaces/collections';
import { saga as manifestSaga } from './spaces/manifests';
import { saga as frameSaga } from './spaces/frames';

var sagas = [iiifResourceSaga, collectionSaga, manifestSaga, frameSaga];

export default sagas;